


















































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: { 
      
  }
})
export default class ListWithItems extends Vue {
  // @Prop({default: false}) disabled : boolean;
  @Prop({default: ''}) listTitle : string;
  @Prop({default: false}) showOnlyIcons : boolean;
  @Prop({default: {}}) items : object;
  @Prop({default: 'white'}) itemsColor : Array<object>;
  @Prop({default: 'black'}) defaultColor : string;
  @Prop({default: ''}) wrapperClass : string;
  selectedItems: Array<object> = [];

  



  @Emit()
  itemChanged(item){
    return item
  }

  itemChangedIcon(item){
    if(!item.disabled){
      item['checked'] = !item['checked'];
    }
    this.itemChanged(item);
  }


  mounted(){
      
  }

  
}
